import './App.css';
import Navbar from './Components/Navbar';
import Form from './Components/Form';
import Header from './Components/Header';
import Footer from './Components/Footer';

function App() {

  return (
    <>
      <Navbar heading="CoverUP" />
      <Header/>
      <Form/>
      <Footer/>
    </>
  );
}

export default App;
